import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { LocaleProvider } from './LocaleContext';
import { NotificationProvider } from './NotificationContext';
import { VoiceCallProvider } from './VoiceCallContext';
import { SystemWebSocketProvider } from './SystemWebSocketContext';
import { ChatRequestsProvider } from './ChatRequestsContext';
import GlobalNotification from './components/GlobalNotification';
import SystemWebSocket from './components/SystemWebSocket';
import ChatRequestsTracker from './components/ChatRequestsTracker';
import ChatNavigationBridge from './components/ChatNavigationBridge';
import IncomingRequestsBadge from './components/IncomingRequestsBadge';
import HomePage from './HomePage';
import ForgotPasswordPage from './ForgotPasswordPage';
import RegisterPage from './RegisterPage';
import LoginPage from './LoginPage';
import UserWorkspacePage from './UserWorkspacePage';
import AdminPage from './AdminPage';
import ProfilePage from './ProfilePage';
import ResetPasswordPage from './ResetPasswordPage';
import ActivationPage from './ActivationPage';
import TwoFactorAuthPage from './TwoFactorAuthPage';
import NotFoundPage from './NotFoundPage';
import PrivateRoute from './PrivateRoute';
import IncomingCallOverlay from './components/call/IncomingCallOverlay';
import ActiveCallScreen from './components/call/ActiveCallScreen';
import { purgeLegacySensitiveStorage } from './utils/browserStorage';

purgeLegacySensitiveStorage();

const App = () => {
  return (
    <ThemeProvider>
    <LocaleProvider>
    <NotificationProvider>
      <SystemWebSocketProvider>
        <VoiceCallProvider>
        <ChatRequestsProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <SystemWebSocket />
          <ChatRequestsTracker />
          <ChatNavigationBridge />
          <GlobalNotification />
          <IncomingCallOverlay />
          <ActiveCallScreen />
          <IncomingRequestsBadge />
          <Routes>
            <Route path="/" element={<HomePage/>} />
            <Route path="/register" element={<RegisterPage/>} />
            <Route path="/login" element={<LoginPage/>} />
            <Route path="/password-forgot" element={<ForgotPasswordPage/>} />
            <Route path="/password-reset" element={<ResetPasswordPage/>} />
            <Route path="/activate" element={<ActivationPage/>} />
            <Route path="/chats" element={<PrivateRoute><UserWorkspacePage/></PrivateRoute>} />
            <Route path="/admin" element={<PrivateRoute><AdminPage/></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><ProfilePage/></PrivateRoute>} />
            <Route path="/2fa" element={<PrivateRoute><TwoFactorAuthPage/></PrivateRoute>} />
            <Route path="*" element={<NotFoundPage/>} />
          </Routes>
      </Router>
        </ChatRequestsProvider>
        </VoiceCallProvider>
      </SystemWebSocketProvider>
    </NotificationProvider>
    </LocaleProvider>
    </ThemeProvider>
  );
};

export default App;
